import { i18n } from '@/i18n';
import {
	getUnidayUniversityListAPI,
	importUnidayUniversityAPI,
	createUnidayUniversityAPI,
	updateUnidayUniversityAPI,
} from '../../services/api/unidayUniversities.api';
import {
	GET_UNIDAY_UNIVERSITY_LIST_REQUEST,
	GET_UNIDAY_UNIVERSITY_LIST_SUCCESS,
	GET_UNIDAY_UNIVERSITY_LIST_FAILURE,
	IMPORT_UNIDAY_UNIVERSITY_REQUEST,
	IMPORT_UNIDAY_UNIVERSITY_SUCCESS,
	IMPORT_UNIDAY_UNIVERSITY_FAILURE,
	CREATE_UNIDAY_UNIVERSITY_REQUEST,
	CREATE_UNIDAY_UNIVERSITY_SUCCESS,
	CREATE_UNIDAY_UNIVERSITY_FAILURE,
	UPDATE_UNIDAY_UNIVERSITY_REQUEST,
	UPDATE_UNIDAY_UNIVERSITY_SUCCESS,
	UPDATE_UNIDAY_UNIVERSITY_FAILURE,
} from '../types';
import {
	transformedUnidayUniversityList,
	transformedUnidayUniversityForm,
} from '../../assets/js/transform/unidayUniversities';
import { transformedMeta } from '../../assets/js/transform/meta';

const showSuccessToast = (dispatch) => dispatch('toast/showToast', {
	content: i18n.t('global.successMessage'),
	header: i18n.t('global.successMessageTitle'),
	type: 'success',
}, { root: true });

export default {
	namespaced: true,
	state: {
		list: {
			isLoading: false,
			data: [],
			// ค่าดิบจาก API — ใช้เติมฟอร์มใน drawer edit (ไม่มี API detail แยก)
			raw: [],
			meta: transformedMeta(),
			error: false,
		},
		import: {
			isImporting: false,
		},
		form: {
			isSubmitting: false,
		},
	},
	getters: {
		getUnidayUniversityFormById: (state) => (id) => {
			const item = state.list.raw.find((university) => university.id === id);
			return item ? transformedUnidayUniversityForm(item) : null;
		},
	},
	mutations: {
		[GET_UNIDAY_UNIVERSITY_LIST_REQUEST](state) {
			state.list.isLoading = true;
			state.list.data = transformedUnidayUniversityList();
			state.list.raw = [];
			state.list.meta = transformedMeta();
			state.list.error = false;
		},
		[GET_UNIDAY_UNIVERSITY_LIST_SUCCESS](state, { data = [], meta = {} } = {}) {
			state.list.isLoading = false;
			state.list.data = transformedUnidayUniversityList(data);
			state.list.raw = data;
			state.list.meta = transformedMeta(meta);
		},
		[GET_UNIDAY_UNIVERSITY_LIST_FAILURE](state) {
			state.list.isLoading = false;
			state.list.error = true;
		},
		[IMPORT_UNIDAY_UNIVERSITY_REQUEST](state) {
			state.import.isImporting = true;
		},
		[IMPORT_UNIDAY_UNIVERSITY_SUCCESS](state) {
			state.import.isImporting = false;
		},
		[IMPORT_UNIDAY_UNIVERSITY_FAILURE](state) {
			state.import.isImporting = false;
		},
		[CREATE_UNIDAY_UNIVERSITY_REQUEST](state) {
			state.form.isSubmitting = true;
		},
		[CREATE_UNIDAY_UNIVERSITY_SUCCESS](state) {
			state.form.isSubmitting = false;
		},
		[CREATE_UNIDAY_UNIVERSITY_FAILURE](state) {
			state.form.isSubmitting = false;
		},
		[UPDATE_UNIDAY_UNIVERSITY_REQUEST](state) {
			state.form.isSubmitting = true;
		},
		[UPDATE_UNIDAY_UNIVERSITY_SUCCESS](state) {
			state.form.isSubmitting = false;
		},
		[UPDATE_UNIDAY_UNIVERSITY_FAILURE](state) {
			state.form.isSubmitting = false;
		},
	},
	actions: {
		async getUnidayUniversities({ commit }, query = {}) {
			try {
				commit(GET_UNIDAY_UNIVERSITY_LIST_REQUEST);
				const { data } = await getUnidayUniversityListAPI(query);
				commit(GET_UNIDAY_UNIVERSITY_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_UNIDAY_UNIVERSITY_LIST_FAILURE);
			}
		},
		// 204 = เข้า queue แล้ว (ผลดูที่ Import History) · 422 = ไฟล์ไม่ผ่าน → throw ต่อให้ view โชว์รายการ error
		async importUnidayUniversities({ commit }, { file, config = {} } = {}) {
			try {
				commit(IMPORT_UNIDAY_UNIVERSITY_REQUEST);
				await importUnidayUniversityAPI(file, config);
				commit(IMPORT_UNIDAY_UNIVERSITY_SUCCESS);
			} catch (error) {
				commit(IMPORT_UNIDAY_UNIVERSITY_FAILURE);
				throw error;
			}
		},
		// error (เช่น 422 customer_id ซ้ำ) ให้ drawer ดึงไปโชว์ใต้ช่อง → throw ต่อ ไม่ขึ้น toast เอง
		async createUnidayUniversity({ commit, dispatch }, params = {}) {
			try {
				commit(CREATE_UNIDAY_UNIVERSITY_REQUEST);
				await createUnidayUniversityAPI(params);
				commit(CREATE_UNIDAY_UNIVERSITY_SUCCESS);
				showSuccessToast(dispatch);
			} catch (error) {
				commit(CREATE_UNIDAY_UNIVERSITY_FAILURE);
				throw error;
			}
		},
		async updateUnidayUniversity({ commit, dispatch }, { id, params = {} } = {}) {
			try {
				commit(UPDATE_UNIDAY_UNIVERSITY_REQUEST);
				await updateUnidayUniversityAPI(id, params);
				commit(UPDATE_UNIDAY_UNIVERSITY_SUCCESS);
				showSuccessToast(dispatch);
			} catch (error) {
				commit(UPDATE_UNIDAY_UNIVERSITY_FAILURE);
				throw error;
			}
		},
	},
};
